module.exports = __webpack_public_path__ + "boxed-bg.7799dece2c79854f63f0.jpg";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/img/boxed-bg.jpg
// module id = ../../../../../src/assets/img/boxed-bg.jpg
// module chunks = styles